import {UI} from "../../../stem-core/src/ui/UIBase";

import {AdBlockerDisable} from "../pages/panels/donation/components/AdBlockerDisable";
import {Link} from "../../../stem-core/src/ui/UIPrimitives";
import {Messages} from "../../Messages";
import {isSmallScreen} from "../../Utils";
import {styleRule, styleRuleInherit} from "../../../stem-core/src/decorators/Style";
import {registerStyle} from "../../../stem-core/src/ui/style/Theme";
import {collapseIframe} from "../../widget/misc/WidgetUtils";
import {DonationPanel} from "../pages/panels/donation/DonationPanel";
import {BasePanelStyle} from "../pages/panels/BasePanel";


class AdBlockerDonateStyle extends BasePanelStyle {
    @styleRuleInherit
    paywallPage = {
        fontFamily: "Open Sans",
        width: 715,
        textAlign: "center",
    };

    @styleRuleInherit
    paywallPagePopup = {
        padding: () => isSmallScreen() ? "30px 18px 18px !important" : "30px 42px !important",
    };

    @styleRule
    link = {
        color: this.themeProps.MERCHANT_LINK,
        fontSize: () => isSmallScreen() ? this.themeProps.MERCHANT_FONT_SIZE_NORMAL : this.themeProps.MERCHANT_FONT_SIZE_LARGE,
        fontWeight: this.themeProps.MERCHANT_FONT_WEIGHT_REGULAR,
        marginTop: 12,
    };

    @styleRule
    separatorLine = {
        height: 1,
        background: this.themeProps.AD_BLOCKER_SEPARATOR_LINE_COLOR,
        margin: () => isSmallScreen() ? "12px 0" : "18px 0",
        width: "100%",
    }
}

@registerStyle(AdBlockerDonateStyle)
export class AdBlockerDonate extends DonationPanel {
    widthValue = null;

    render() {
        const {styleSheet} = this;

        return [
            <AdBlockerDisable/>,
            <div className={styleSheet.separatorLine} />,
            super.render(),
            <Link value={Messages.adBlockerDonateContinueToSite} className={styleSheet.link} onClick={collapseIframe}/>,
        ];
    }
}
